import React from 'react';

import { Button, FormLabel, Paper } from '@material-ui/core';
import { Description as DocIcon } from '@material-ui/icons';

import './styles.css';

class ImageSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? this.props.value.contents : null,
      filetype: this.props.value ? this.props.value.contents.split(':')[1].split(';')[0] : null,
      filename: this.props.value ? this.props.value.filename : null,
      platform: navigator.platform,
      allowAllFiles: ['iPhone'].indexOf(navigator.platform) < 0
    };
    this.file = React.createRef();
  }

  click() {
    this.file.current.click();
  }

  clear() {
    this.setState({ value: null, filename: '', filetype: '' });
    if (this.props.onChange) this.props.onChange(null);
  }

  change(e) {
    const reader = new FileReader();
    const filedata = e.target.files;

    if (filedata.length === 0) return;

    if (this.props.min_filesize && filedata[0].size < this.props.min_filesize) {
      this._change(null);
      this.setState({
        value: null,
        filetype: null,
        filename: null,
        error: 'The provided file is too small'
      });

      if (this.props.onError) this.props.onError(this.state.error);
      return;
    }

    if (this.props.max_filesize && filedata[0].size > this.props.max_filesize) {
      this._change(null);
      this.setState({
        value: null,
        filetype: null,
        filename: null,
        error: 'The provided file is too large'
      });

      if (this.props.onError) this.props.onError(this.state.error);
      return;
    }

    const filename = filedata[0].name.split('\\').reduce((acc, cur) => cur);

    reader.onload = (e) => {
      var imagedata = e.target.result;
      if (filedata[0].type.startsWith('image/') && this.props.max_size) {
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        const img = new Image();
        img.style.display = 'none';

        document.body.appendChild(canvas);
        img.src = imagedata;
        document.body.appendChild(img);
        img.onload = () => {
          var ctx = canvas.getContext('2d');
          var canvasCopy = document.createElement('canvas');
          var copyContext = canvasCopy.getContext('2d');
          var ratio = 1;

          if (img.width > this.props.max_size[0]) {
            ratio = this.props.max_size[0] / img.width;
          } else if (img.height > this.props.max_size[1]) {
            ratio = this.props.max_size[1] / img.height;
          }
          canvasCopy.width = img.width;
          canvasCopy.height = img.height;
          copyContext.drawImage(img, 0, 0);

          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;
          ctx.drawImage(
            canvasCopy,
            0,
            0,
            canvasCopy.width,
            canvasCopy.height,
            0,
            0,
            canvas.width,
            canvas.height
          );
          const resized = canvas.toDataURL('image/jpeg', 0.8);
          this._change({
            filename: filename,
            contents: resized
          });
          canvas.parentNode.removeChild(canvas);
          img.parentNode.removeChild(img);
        };
      } else {
        this._change({
          filename: filename,
          contents: imagedata
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    this.setState({
      filename: e.target.value,
      filetype: filedata[0].type
    });
  }

  _change(imagedata) {
    if (imagedata) {
      this.setState({
        filename: imagedata.filename,
        value: imagedata.contents,
        error: null
      });
    }
    if (this.props.onChange) this.props.onChange(imagedata);
  }

  render() {
    const {
      value,
      width,
      height,
      onError,
      onChange,
      label,
      labelAppend,
      prompt,
      max_size,
      min_filesize,
      accept,
      acceptAll,
      helperText,
      ...extra
    } = this.props;

    return (
      <div
        className={
          'imageselector' +
          (this.state.filetype && !this.state.filetype.startsWith('image/') ? ' doc' : '') +
          (this.state.error ? ' error' : '')
        }
        {...extra}>
        {label ? <FormLabel>{label}</FormLabel> : null}
        {labelAppend}
        <Paper
          className="image"
          elevation={9}
          style={{
            backgroundImage: 'url(' + (this.state.value ? this.state.value : '') + ')',
            height: height ? height + 'px' : 'auto',
            width: width ? width + 'px' : 'auto'
          }}>
          <input
            // accept={ acceptAll ? (this.state.allowAllFiles ? "*/*" : "image/*, .pdf, .doc, .docx") : "image/*, .pdf, .doc, .docx" }
            accept={'image/*, .pdf, .doc, .docx .xls, .xlsx, .csv'}
            id="recipe-image"
            multiple
            type="file"
            ref={this.file}
            onChange={(e) => this.change(e)}
          />
          <button type="button" onClick={() => this.file.current.click()}>
            <FormLabel className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl">
              {this.state.filetype && !this.state.filetype.startsWith('image/') ? <DocIcon /> : ''}
              {this.state.filetype
                ? this.state.filename && !this.state.filetype.startsWith('image/')
                  ? this.state.filename.split('\\').reduce((acc, cur) => (acc = cur))
                  : ''
                : this.state.error
                ? this.state.error
                : prompt
                ? prompt
                : 'Click to choose image'}
            </FormLabel>
          </button>
        </Paper>
        {helperText ? <FormLabel className="helper">{helperText}</FormLabel> : ''}
        {this.props.clearable ? (
          <Button variant="contained" onClick={() => this.clear()}>
            Clear
          </Button>
        ) : null}
      </div>
    );
  }
}

export default ImageSelector;
